module.exports = __webpack_public_path__ + "static/media/loader.00ad3c5e.svg";